export default __webpack_public_path__ + "pgnv-assets/e24792fc15269fee4c323453fb9ff672.png";